import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@core/authentication/services';
import { UserGroupRoles } from '@core/constants';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: false
})
export class UsersComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly authenticationService = inject(AuthenticationService);

  internalUserBack = false;
  internalUserAccess = this.authenticationService.checkUserRole(
    UserGroupRoles.INTERNALUSERMANAGEMENT
  );
  externalUserAccess = this.authenticationService.checkUserRole(
    UserGroupRoles.EXTERNALUSERMANAGEMENT
  );
  activeTab: string = 'external';
  
  initExternal = false;
  initInternal = false;

  ngOnInit(): void {
    if (this.route.snapshot.queryParams.index || (this.internalUserAccess && !this.externalUserAccess)) {
      this.activeTab = 'internal';
    }

    // Set initialization flags
    this.activeTab === 'external' ? this.initExternal = true : this.initInternal = true;
  }

  onTabChange(next: 'internal' | 'external') {
    if (next === 'external') this.initExternal = true;
    if (next === 'internal') this.initInternal = true;
  }
}
